import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DocumentsEventsService {
  private refreshTableSource = new Subject<any>();
  refreshTable$ = this.refreshTableSource.asObservable();

  emitRefreshTable(data?: any) {
    this.refreshTableSource.next(data);
  }
}
